/**
 * Convert file to Base64 format
 *
 * @param file
 * @returns {Promise<unknown>}
 */
export const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);

    const onLoad = () => {
      resolve(reader.result);
      reader.removeEventListener("load", onLoad);
    };

    reader.addEventListener("load", onLoad);

    const onError = (error) => {
      reject(error);
      reader.removeEventListener("error", onError);
    };

    reader.addEventListener("error", onError);
  });
};
/**
 * Return "FormData" with infoObject properties
 *
 * @param {Object} infoObject - entry object
 * @returns {FormData}
 */
export const getFormDataObject = (infoObject) => {
  const formDataObject = new FormData();

  Object.keys(infoObject).forEach(itemName => {
    formDataObject.append(itemName, infoObject[itemName]);
  });

  return formDataObject;
};